import SubCategoriesContainer from "./SubCategoriesContainer";

export default SubCategoriesContainer;
